<template>
    <div>
        <a :href="numero" class="float" target="_blank">
            <ion-icon name="logo-whatsapp" class="my-float" size="large"></ion-icon>
        </a>
    </div>
</template>


<script>
export default {
    data() {
        return {
            numero: 'https://api.whatsapp.com/send?phone=' + this.$whatsApp + '&text=Hola Komvac'
        }
    }
}
</script>

<style scoped>
    .float {
        position:fixed;
        width:60px;
        height:60px;
        bottom:40px;
        right:40px;
        background-color:#25d366;
        color:#FFF;
        border-radius:50px;
        text-align:center;
        font-size:30px;
        box-shadow: 2px 2px 3px #999;
        z-index:100;
    }

    .my-float {
        margin-top:14px;
        margin-left:14px;
    }
</style>